export default __webpack_public_path__ + "static/media/Icon awesome-ad.0cf65135.svg";